module.exports = __webpack_public_path__ + "static/UpNorth_Case_Thumbnail-4e15a5676c078d9f984e45a3717bbb51.png";